import { Action } from 'redux'
import { _ServiceRequest } from '../../types/serviceRequest'

export const SET_SERVICE_REQUEST_LIST = 'SET_SERVICE_REQUEST_LIST'
export const SET_SELECTED_SERVICE_REQUEST = 'SET_SELECTED_SERVICE_REQUEST'

interface SetServiceRequestListAction extends Action {
    type: typeof SET_SERVICE_REQUEST_LIST
    serviceRequestList: _ServiceRequest[]
}

interface SetServiceRequestIdAction extends Action {
    type: typeof SET_SELECTED_SERVICE_REQUEST
    serviceRequest?: _ServiceRequest
}

export type ServiceRequestActionTypes =
    | SetServiceRequestListAction
    | SetServiceRequestIdAction
